import React from "react";
import { useTranslation } from "react-i18next";


export default function Interier() {
  const { t } = useTranslation();

  return (
    <div className="sonata-exterior">
      {/* <div className="second-parth-tucson">
        <div>
          <h2 className="exterier-header">{t("tucson.interier1")} </h2>
        </div>
      </div> */}
      <div className="first-parth-sonata">
        <div className="tit-wrap">
          <h1>{t("tucson.higlights1")}</h1>

          <video width="900" controls muted loop autoPlay={true}>
          <source
            src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/suv/tucson-nx4-2023/design/video/tucson-design-rear-film-01-original.mp4"
            type="video/mp4"
          />
        </video>
        </div>
        <div className="tit-wrap ">
          <h2>{t("tucson.higlights9")}</h2>

          <video width="900" controls muted loop autoPlay={true}>
          <source
            src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/suv/tucson-nx4-2023/design/video/tucson-design-rear-film-02-original.mp4"
            type="video/mp4"
          />
        </video>
        </div>
        <div className="tucson-interier-parth">
          <div>
            <img
              src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/suv/tucson-nx4-2023/design/tucson-design-interior-console-original.jpg"
              alt="tucson"
              />
            <p>
            {t("tucson.higlights2")}
            </p>
          </div>
          <div>
            <img
              src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/suv/tucson-nx4-2023/design/tucson-design-interior-mood-lamp-original.jpg"
              alt="tucson"
              />
            <p>{t("tucson.higlights3")}</p>
          </div>
        </div>
        <div className="tucson-interier-parth">
          <div>
            <img
              src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/suv/tucson-nx4-2023/design/tucson-design-interior-memory-seat-original.jpg"
              alt="tucson"
              />
            <p>
            {t("tucson.higlights4")}

            </p>
          </div>
          <div>
            <img
              src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/suv/tucson-nx4-2023/design/tucson-design-interior-walk-in-device-original.jpg"
              alt="tucson"
              />
            <p>{t("tucson.higlights5")}
</p>
          </div>
        </div>
      </div>
    </div>
  );
}
